<template>
		<v-layout row justify-center>
			<v-flex>
				<v-card-text class="background darken-1">
					<v-text-field
						solo
						:loading="suifaInfos.loading"
						v-model="suifaRef"
						name="name"
						label="Référence suifa"
						id="id"
						hide-details
						@input="getBehiveAssetInfo($event)">
						<v-tooltip
							slot="append"
							bottom>
							<v-btn
								@click="getBehiveAssetInfo(suifaRef)"
								icon
								small
								:disabled="suifaInfos.loading"
								slot="activator">
								<span v-if="suifaInfos.loading">
									<v-progress-circular
										indeterminate
										:size="35"
										:width="5">
									</v-progress-circular>
								</span>
								<span v-else>
									<v-icon>
										youtube_searched_for
									</v-icon>
								</span>
							</v-btn>
							Get data from Behive/Suifa
						</v-tooltip>
					</v-text-field>

					<div v-if="errors">
						<p
							class="error--text"
							v-for="error in errors"
							:key="error.id">
							{{ error }}
						</p>
					</div>

					<div v-if="suifaInfos.data && suifaInfos.data.t_aux_proprio" class="mt-2">
						<p v-if="suifaInfos.data.t_aux_proprio.t_libelle || suifaInfos.data.t_aux_proprio.t_auxiliaire" class="mb-1">
							<strong class="primary--text">Ayant droit :</strong>
							{{ suifaInfos.data.t_aux_proprio.t_libelle }} - ({{ suifaInfos.data.t_aux_proprio.t_auxiliaire }})
						</p>
						<p class="m-0">
							<strong class="primary--text">Asset :</strong>
							<v-chip small label v-if="suifaInfos.data.type_sup.code_type_sup" class="mx-0">
								{{ suifaInfos.data.type_sup.code_type_sup }}
							</v-chip>
							<span v-if="suifaInfos.data.titre.titre_princ" class="mb-1">
								{{ suifaInfos.data.titre.titre_princ }}
							</span>
							<strong>
								<span v-if="suifaInfos.data.asset_size && String(suifaInfos.data.asset_size).length < 10" class="mb-1">
								-
									{{ $weight.bitRoundToTwo(suifaInfos.data.asset_size, 2) }} Mo
								</span>
								<span v-else-if="suifaInfos.data.asset_size" class="mb-1">
									{{ $weight.bitRoundToTwo(suifaInfos.data.asset_size, 3) }} Go
								</span>
							</strong>
						</p>
						<p v-if="suifaInfos.data.type_sup.code_type_sup" class="mb-1">
							<strong class="primary--text">Contrat :</strong>
							<span v-if="this.localHasContract">Oui</span>
							<span v-else>Non</span>
						</p>
					</div>

					<div class="mt-3" v-if="suifaInfos.data && suifaInfos.data.cpls && suifaInfos.data.cpls.length > 0">
						<h6><strong class="primary--text">Liste des DCP :</strong></h6>
						<div v-for="cpls in suifaInfos.data.cpls" :key="cpls.id">
							<v-chip label small class="mx-0 w-45">
								{{ cpls.folder_type }}
							</v-chip>
							{{ cpls.folder_name }}
							<span v-if="cpls.folder_size > 0">
								-
								<span v-if="(String(cpls.folder_size).length < 10)">
									<strong>
										{{ $weight.bitRoundToTwo(cpls.folder_size, 2) }} Mo
									</strong>
								</span>
								<span v-else>
									<strong>
										{{ $weight.bitRoundToTwo(cpls.folder_size, 3) }} Go
									</strong>
								</span>
							</span>
							<span v-else-if="cpls.folder_taille > 0">
								-
								<span v-if="(String(cpls.folder_taille).length < 10)">
									<strong>
										{{ $weight.bitRoundToTwo(cpls.folder_taille, 2) }} Mo
									</strong>
								</span>
								<span v-else>
									<strong>
										{{ $weight.bitRoundToTwo(cpls.folder_taille, 3) }} Go
									</strong>
								</span>
							</span>
						</div>
					</div>

				</v-card-text>
				<v-card-actions
					v-if="!errors.length && this.suifaInfos.data"
					class="">
					<v-select
						dense
						flat
						prepend-inner-icon="archive"
						:items="stockageList"
						v-model="storageType"
						label="Type de stockage"/>
					<v-spacer></v-spacer>
					<v-switch
						class="switch-label"
						color="primary"
						v-model="removeSource"
						label="Supprimer la source"/>
					<v-spacer></v-spacer>
					<v-btn
						class="mr-0"
						:disabled="disableSubmitButton"
						@click="submit(); $emit('close')"
						color="primary color--text"
						:loading="submitLoading">
						Envoyer
					</v-btn>
				</v-card-actions>
			</v-flex>
		</v-layout>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data () {
		return {
			stockageList: [
				{ value: 'catalog', text: 'Catalog' },
				{ value: 'maestro', text: 'Maestro' }
			],
			storageType: { value: 'catalog', text: 'Catalog' },
			behiveCat: ['hot', 'catalog'],
			ovFolder: '',
			removeSource: false,
			suifaRef: '',
			computedSuifaRef: '',
			suifaInfos: {
				data: null,
				loading: false
			},
			localHasContract: false,
			manifest: null,
			jobTypes: ['DCPFOL', 'DCPCOP'],
			errors: [],
			submitLoading: false
		}
	},
	computed: {
		...mapGetters([
			'user'
		]),

		disableSubmitButton () {
			if (this.suifaInfos.loading) {
				return true
			}
			return false
		}
	},

	methods: {

		getTAuxContract (tAux) {
			return new Promise((resolve, reject) => {
				this.$apiPublic.contract_search(tAux)
					.then(response => {
						resolve(response)
					})
					.catch(error => {
						console.error(error)
						reject(error)
					})
			})
		},

		getAssetInfo (ref) {
			return new Promise((resolve, reject) => {
				let params = {
					ref_materiel: ref,
					per_page: 100
				}
				this.$apiPublic.material_search(params, true)
					.then(response => {
						resolve(response)
					})
					.catch(err => {
						console.error(err)
						reject(err)
					})
			})
		},

		async getAlreadyIngestedRef (suifa_ref, category) {
			return new Promise((resolve, reject) => {
				let params = {
					'type_sup_id': 113,
					'suifa_ref': suifa_ref,
					'category': category
				}
				this.$apiPublic.material_search(params)
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						console.error(err)
						reject(err)
					})
			})
		},

		async getBehiveAssetInfo (ref) {
			this.suifaInfos.loading = true
			this.storageType = { value: 'catalog', text: 'Catalog' }
			this.computedSuifaRef = ref.replace(/(_|-|\/|\\)/g, '/')

			// replaces spaces and tabs
			this.computedSuifaRef = this.computedSuifaRef.replace(/(\t|\s+)/g, '')

			let refSuifaRegEx = /[0-9]{2}\/[0-9]{2}\/[a-zA-Z0-9]{4}/g

			// if (ref.match(refSuifaRegEx))
			if (this.computedSuifaRef.match(refSuifaRegEx)) {
				let hotRef = await this.getAlreadyIngestedRef(this.computedSuifaRef, 'hot')
				let catalogRef = await this.getAlreadyIngestedRef(this.computedSuifaRef, 'catalog')
				let jobExists = hotRef.concat(catalogRef)

				if (jobExists.length) {
					// if job exists in maestro
					this.suifaInfos.loading = false
					this.errors = [`La référence '${this.suifaRef}' a déjà été ingestée (ou en cours d'ingest) par Maestro.`]
				} else {
					let activeAssets
					this.getAssetInfo(this.computedSuifaRef)
						.then(response => {
							activeAssets = response.filter(asset => {
								return this.behiveCat.includes(asset.behive_category)
							})
							// if no active assets
							if (response.length === 0) {
								this.errors = []
								this.manifest = null
								this.errors.push(
									'Pas d\'asset en catalogue ou stockage chaud pour cette référence. ' + `${this.suifaRef}`
								)
								this.suifaInfos.data = {...response}
								this.suifaInfos.loading = false
								return
							}
							return activeAssets
						})
						.then(response => {
							// reindex asset before getting infos
							return response.map(asset => {
								this.$ApiNexus.reindex_asset(asset.mat_id)
							})
						})
						.then(response => {
							// wait some time because reindex takes time
							return new Promise((resolve) => {
								setTimeout(() => {
									resolve()
								}, 1500)
							})
						})
						.then(response => this.getAssetInfo(this.computedSuifaRef))
						.then(response => {
							activeAssets = response.filter(asset => {
								return this.behiveCat.includes(asset.behive_category)
							})
							return activeAssets
						})
						.then(response => {
							// if we find active assets
							if (response.length > 0) {
								for (let activeAsset of response) {
									if (this.jobTypes.includes(activeAsset.type_sup.code_type_sup)) {
										this.manifest = null
										this.suifaInfos.data = {...activeAsset}
										this.suifaInfos.loading = false
										this.errors = []
										this.getTAuxContract(this.suifaInfos.data.t_aux_proprio.t_auxiliaire)
											.then(contract => {
												// if client has catalog subscription
												if (contract) {
													if (contract.results.length > 0) {
														let hasContract = contract.results[0].has_storage_catalog
														if (hasContract) {
															this.localHasContract = true
															this.storageType = this.stockageList[0]
														}
													} else {
														this.localHasContract = false
														this.storageType = this.stockageList[1]
													}
												}
											})

										break
									} else if (activeAsset.type_sup && !this.jobTypes.includes(activeAsset.type_sup.code_type_sup)) {
										this.errors = []
										this.manifest = null
										this.errors.push(`Type d'asset non pris en charge. (${activeAsset.type_sup.code_type_sup})`)
										this.suifaInfos.data = {...activeAsset}
										this.suifaInfos.loading = false
										// if activeAsset has not cpls array
									} else if (activeAsset.cpls.length < 1) {
										this.errors = []
										this.manifest = null
										this.errors.push('CPLS manquant' + ` (${activeAsset.type_sup.code_type_sup})`)
										this.suifaInfos.data = {...activeAsset}
										this.suifaInfos.loading = false
										// if not in catalog or hot
									}
								}
							// if no active assets
							} else {
								this.errors = []
								this.manifest = null
								this.errors.push(
									'Pas d\'asset en catalogue ou stockage chaud pour cette référence. ' + `${this.suifaRef}`
								)
								this.suifaInfos.data = null
								this.suifaInfos.loading = false
							}
						})
						.catch(error => {
							console.error(error)
							this.suifaInfos.loading = false
						})
				}
			}
		},

		submit () {
			this.submitLoading = true
			let data = {
				jd_id: window.appConfig.maestro_wf['asset dcp ingest'].id,
				parameters: {
					'suifa_ref': this.computedSuifaRef,
					'remove_source': this.removeSource,
					'server_storage': this.storageType.value
				}
			}
			this.$ApiMaestro.jobrequest_create(data)
				.then(response => {
					this.submitLoading = false
					this.$emit('maestroFormSent', response)
				})
				.catch(error => {
					console.error(error)
					this.submitLoading = false
					this.$emit('maestroFormErrorSending', error.response)
				})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.v-input--selection-controls.v-input.switch-label label.v-label {
		margin: 0 !important;
	}

	.v-input--switch.switch-label {
		max-width: 100% !important;
	}
	.w-45 {
		min-width: 45px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_dcp.vue